import { render, staticRenderFns } from "./MensagemTopoTabela.vue?vue&type=template&id=3f5a7bf3&scoped=true"
import script from "./MensagemTopoTabela.vue?vue&type=script&lang=js"
export * from "./MensagemTopoTabela.vue?vue&type=script&lang=js"
import style0 from "./MensagemTopoTabela.vue?vue&type=style&index=0&id=3f5a7bf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5a7bf3",
  null
  
)

export default component.exports